<template>
  <v-app>
    <v-main>
      <div class="layout-container">
        <template v-if="!authChecking">
          <Navbar v-if="shouldShowAppBar" />
          <router-view class="router-view" />
          <fooTer class="footer" />
          <SnackBar />
        </template>
        <v-overlay v-else> <loader /> </v-overlay>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import fooTer from "./components/MainFooter.vue";
import loader from "./components/MainLoader.vue";
import SnackBar from "@/components/SnackBar.vue";
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Navbar from "./components/NavBar.vue";

export default {
  name: "App",
  components: { fooTer, loader, Navbar, SnackBar },
  setup() {
    const route = useRoute();
    const store = useStore();
    const excludedRoutes = ["/login", "/register", "/recover-password"];
    const authChecking = computed(() => store.state.users.authChecking);

    const shouldShowAppBar = computed(() => {
      return !excludedRoutes.includes(route.path);
    });

    onMounted(async () => {
      try {
        await store.dispatch("checkAuth");
      } catch (error) {
        console.error("Error checking auth:", error);
      } finally {
        authChecking.value = false;
      }
    });

    return {
      shouldShowAppBar,
      authChecking,
    };
  },
};
</script>

<style scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
}

.app-bar {
  flex-shrink: 0;
}

.router-view {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
}

.footer {
  flex-shrink: 0;
  position: relative;
}
</style>
